import '../enums/billing/AccountGlobalStatusEnum.es.js';
import '../enums/billing/AccountingStatusEnum.es.js';
import '../enums/billing/AssetPurchaseFormatEnum.es.js';
import '../enums/billing/AssetPurchaseUnavailableCodeEnum.es.js';
import '../enums/billing/BillingSystemEnum.es.js';
import '../enums/billing/CreditKindEnum.es.js';
import '../enums/billing/InvoiceStatusEnum.es.js';
import '../enums/billing/DiscountTypeEnum.es.js';
import '../enums/billing/PlanFrequencyEnum.es.js';
import '../enums/billing/ServiceOffersKindEnum.es.js';
import '../enums/billing/ServiceStatusEnum.es.js';
import '../enums/billing/SubscriptionStatusEnum.es.js';
import '../enums/billing/SubscriptionMigrationTypeEnum.es.js';
import '../enums/billing/SubscriptionMigrationTimingEnum.es.js';
import '../enums/billing/SubscriptionServiceOfferEnum.es.js';
import '../enums/billing/BillingCommitmentEnum.es.js';
import '../enums/collaboration/ActorEnum.es.js';
import '../enums/collaboration/EntityTypeEnum.es.js';
import '../enums/AppHomePageEnum.es.js';
import '../enums/ApplicationEnum.es.js';
import '../enums/CreditCardEnum.es.js';
import '../enums/DollarSignCurrenciesEnum.es.js';
import '../enums/DownloadBinStatusEnum.es.js';
import '../enums/ExternalTypeEnum.es.js';
import '../enums/FeatureEnum.es.js';
import '../enums/FeatureFlagEnum.es.js';
import '../enums/FileSelectionSourceEnum.es.js';
import '../enums/GenresEnum.es.js';
import { IntensityEnum } from '../enums/IntensityEnum.es.js';
import '../enums/InternalErrorEnum.es.js';
import '../enums/LibraryItemEnum.es.js';
import '../enums/MasteringStyleEnum.es.js';
import '../enums/MfeApplicationEnum.es.js';
import '../enums/NotificationTypeEnum.es.js';
import '../enums/PaymentCycleEnum.es.js';
import '../enums/PaymentMethodEnum.es.js';
import '../enums/ProofOfRightsEnums.es.js';
import '../enums/RegexPatternsEnum.es.js';
import '../enums/ReleaseContributorRoleEnum.es.js';
import '../enums/ReleaseGlobalStateEnum.es.js';
import '../enums/ReleaseLanguagesEnum.es.js';
import '../enums/ReleasePayoutStatusEnum.es.js';
import '../enums/ReleasePayoutGlobalStatusEnum.es.js';
import '../enums/ReleaseStateEnum.es.js';
import '../enums/ServiceProviderStateEnum.es.js';
import '../enums/ReleaseStoreCategoryEnum.es.js';
import '../enums/ReleaseStoreEnum.es.js';
import '../enums/ReleaseTerritoriesEnum.es.js';
import '../enums/ReleaseParentalWarningEnum.es.js';
import '../enums/SessionFlagsEnum.es.js';
import '../enums/ShareReactionTypeEnum.es.js';
import '../enums/SocialNetworksEnum.es.js';
import '../enums/StateEnum.es.js';
import '../enums/TrackTypeEnum.es.js';
import '../enums/UnavailabilityEnum.es.js';
import '../enums/UserInteractionSourceEnum.es.js';
import '../enums/ZeroDecimalCurrenciesEnum.es.js';
import { NoiseReductionLevelEnum } from '../enums/NoiseReductionLevelEnum.es.js';
import '../enums/ReleaseDspsEnum.es.js';
import '../enums/ReleaseDspStatusEnum.es.js';
import '../enums/ProjectsCallSourceTypesEnum.es.js';
import '../enums/LibraryItemTypeEnum.es.js';
import '../enums/PendingItemStateEnum.es.js';
import '../enums/MonetizationEligibilityStateEnum.es.js';
import '../enums/CoverSongOptionsEnum.es.js';
import '../enums/LanguagesEnum.es.js';
import '../enums/LocalesEnum.es.js';

/** @module Classes */ /** typedoc */
class VideoTrackVersion {
    constructor() {
        this.id = null;
        this.creationDate = null;
        this.state = null;
        this.engineVersion = null;
        this.canAddFormats = true;
        this.intensity = IntensityEnum.Medium;
        this.noiseReductionLevel = NoiseReductionLevelEnum.Medium;
    }
}

export { VideoTrackVersion };
